'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';
import { motion, useScroll, useTransform } from 'motion/react';
import Image from 'next/image';
import React from 'react';
const HERO_IMAGES = ['https://images.unsplash.com/photo-1485846234645-a62644f84728?q=80&w=1200', 'https://images.unsplash.com/photo-1547658719-da2b51169166?q=80&w=1200', 'https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?q=80&w=1200'];
export function HeroParallax(t0) {
  const $ = _c(28);
  const {
    className
  } = t0;
  const ref = React.useRef(null);
  const [showParallaxLayers, setShowParallaxLayers] = React.useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setShowParallaxLayers(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  React.useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      target: ref,
      offset: ["start start", "end start"]
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    scrollYProgress
  } = useScroll(t3);
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [0, 1];
    t5 = ["0%", "30%"];
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  const y1 = useTransform(scrollYProgress, t4, t5);
  let t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [0, 1];
    t7 = ["0%", "15%"];
    $[5] = t6;
    $[6] = t7;
  } else {
    t6 = $[5];
    t7 = $[6];
  }
  const y2 = useTransform(scrollYProgress, t6, t7);
  let t8;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [0, 1];
    t9 = ["0%", "25%"];
    $[7] = t8;
    $[8] = t9;
  } else {
    t8 = $[7];
    t9 = $[8];
  }
  const y3 = useTransform(scrollYProgress, t8, t9);
  let t10;
  let t11;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = [0, 0.5];
    t11 = [1, 0];
    $[9] = t10;
    $[10] = t11;
  } else {
    t10 = $[9];
    t11 = $[10];
  }
  const opacity = useTransform(scrollYProgress, t10, t11);
  let t12;
  if ($[11] !== className) {
    t12 = cn("absolute inset-0 overflow-hidden", className);
    $[11] = className;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== opacity || $[14] !== y1) {
    t13 = {
      y: y1,
      opacity
    };
    $[13] = opacity;
    $[14] = y1;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  let t15;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Image src={HERO_IMAGES[0]} alt="" fill={true} className="object-cover" sizes="100vw" priority={true} />;
    t15 = <div className="absolute inset-0 bg-black/70" />;
    $[16] = t14;
    $[17] = t15;
  } else {
    t14 = $[16];
    t15 = $[17];
  }
  let t16;
  if ($[18] !== t13) {
    t16 = <motion.div style={t13} className="absolute inset-0">{t14}{t15}</motion.div>;
    $[18] = t13;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== showParallaxLayers || $[21] !== y2 || $[22] !== y3) {
    t17 = showParallaxLayers ? <><motion.div style={{
        y: y2
      }} className="absolute inset-0 opacity-40"><Image src={HERO_IMAGES[1]} alt="" fill={true} className="object-cover scale-110" sizes="100vw" loading="lazy" /><div className="absolute inset-0 bg-black/50" /></motion.div><motion.div style={{
        y: y3
      }} className="absolute inset-0 opacity-30"><Image src={HERO_IMAGES[2]} alt="" fill={true} className="object-cover scale-105" sizes="100vw" loading="lazy" /><div className="absolute inset-0 bg-black/40" /></motion.div></> : null;
    $[20] = showParallaxLayers;
    $[21] = y2;
    $[22] = y3;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== t12 || $[25] !== t16 || $[26] !== t17) {
    t18 = <div ref={ref} className={t12} aria-hidden={true}>{t16}{t17}</div>;
    $[24] = t12;
    $[25] = t16;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  return t18;
}